<template>
  <v-form @submit.prevent="getActionMethod">
    <v-container>
      <v-row class="mx-4">
        <span class="red--text font-weight-bold">{{
          formValidator.getError("non_field_errors")
        }}</span>
        <v-col cols="12">
          <vue-users-auto-complete
            v-model="formValues.crm_user"
            label="Select User"
            :error-messages="formValidator.getError('user')"
            :params="{ crm_user: 'True' }"
            :prepend-inner-icon="$getIcon('mdiAccountPlus')"
          >
          </vue-users-auto-complete>
          <v-switch
            v-model="formValues.primary"
            disabled
            :label="
              `Toggle the switch to save the user as primary assigned user for the client.`
            "
            color="green"
          >
          </v-switch>
        </v-col>
        <v-col cols="12"> </v-col>
        <v-col cols="12" class="text-right">
          <v-divider class="my-2"></v-divider>
          <v-btn
            :disabled="Object.keys(formValidator.errors).length > 0"
            class="primary"
            type="submit"
          >
            Save
          </v-btn>
          <v-btn type="reset" @click="formValues.crm_user = ''">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
export default {
  props: {
    actionData: {
      type: Object,
      required: false,
      default() {
        return {
          client: "",
          crm_user: "",
          primary: true
        };
      }
    },
    clientSlug: {
      type: String,
      required: false,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      formValues: { ...this.actionData, primary: true },
      formValidator: new FormValidator()
    };
  },
  watch: {
    actionData(val) {
      if (val) {
        this.formValues = { ...val };
      }
    },
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    }
  },
  methods: {
    getActionMethod() {
      if (this.formValues.id) return this.updateClientAssignedUser();
      return this.createClientAssignedUser();
    },
    createClientAssignedUser() {
      const clientAssignedUserAPI = "/api/v1/crm/client-user/";
      this.formValues.client = this.clientSlug;
      this.$axios
        .$post(clientAssignedUserAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created client's assigned user!`,
            color: "green"
          });
          this.$emit("clientAssignedUserFormResponse", "created");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    },
    updateClientAssignedUser() {
      const clientAssignedUserAPI =
        "/api/v1/crm/client-user/" + this.formValues.id + "/";
      this.$axios
        .$patch(clientAssignedUserAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated client's assigned user!`,
            color: "green"
          });
          this.$emit("clientAssignedUserFormResponse", "updated");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    }
  }
};
</script>
